<template>
    <div id="main" class="select-modal">
        <div class="page">
            <div class="aparelhos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('controle-aparelhos') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('colaborador') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('controle-aparelhos') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons"></div>
                </div>

                <div v-if="permissao.update && limiteQdaAtivos">
                    <article class="message is-danger">
                        <div class="message-body">
                            {{ $t('qtde_max_usuario_aparelho') }}
                        </div>
                    </article>
                </div>

                <!-- PESQUISA E FILTROS -->
                <div class="search-and-filter">
                    <div class="columns is-variables is-desktop">
                        <div class="column header-search is-5">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                                tooltipLabel="msg-campo-busca-aparelho"
                            />
                        </div>
                        <div class="column data is-one-quarter">
                            <!-- COMBO APARELHO DE TESTES -->
                            <label v-text="$t('em-teste')" />
                            <vss-select
                                ref="situacaoInput"
                                class="smaller no-clear"
                                v-model="filtros.emTeste"
                                :options="situacoesEmTeste"
                                @input="carregarDados()"
                                :height="40"
                            >
                                <template #multiple-selected="{ selected }">
                                    ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                                </template>
                            </vss-select>
                        </div>
                        <div class="column data is-one-quarter">
                            <!-- SITUACAO -->
                            <label v-text="$t('situacao')" />
                            <vss-select
                                ref="situacaoInput"
                                class="smaller no-clear"
                                label="label"
                                v-model="filtros.situacao"
                                :options="situacoes"
                                @input="carregarDados()"
                                :height="40"
                            >
                                <template #multiple-selected="{ selected }">
                                    ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                                </template>
                            </vss-select>
                        </div>
                        <div class="column is-2" v-if="exportacaoTipo && permissao.export">
                            <div class="mt-2-custom">
                                <div class="data-exporta" v-if="exportacaoTipo.exportapdf == 1">
                                    <b-button 
                                        type="is-primary" 
                                        icon-right="file-pdf" 
                                        @click="checkExport('pdf')"
                                        v-tippy 
                                        :title="$t('msg-tooltip-pdf')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- FILTROS EXTRAS -->
                <b-collapse class="card" animation="slide" @open="onFilterChange" @close="onFilterChange">
                    <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                        <div class="card-header-title">
                            <div class="filtro-header">
                                <b-icon :icon="props.open ? 'menu-down' : 'menu-right'"/>
                                {{ $t('filtros') }}
                            </div>
                        </div>
                    </div>
                    <div class="card-content filter-page">
                        <div class="columns">
                            <div class="column">
                                <label v-text="$t('vendedor')"/>
                                <vss-select
                                    ref="vendedorInput"
                                    class="smaller no-clear"
                                    v-model="vendedorSelected"
                                    :options="vendedorSelect"
                                    :loading="vendedorLoading"
                                    @search="carregarVendedores"
                                    label="nomevendedor"
                                    :height="40"
                                    :closeOnSelect="false"
                                    no-clearfix multiple clearable searchable
                                />
                            </div>
                            <!-- Periodos da data de inclusão do aparelho (ultimo acesso) -->
                            <div class="column">
                                <label for="periodo">
                                    {{ $t("periodo-inicial") }}
                                    <b-icon 
                                        icon="information" 
                                        size="is-small" 
                                        v-tippy 
                                        :title="$t('msg-campo-inicio-ultimo-acesso-aparelho')"
                                    />
                                </label>
                                <verified-date-picker
                                    dateType="startDate"
                                    :value="dataInicioSelected"
                                    :endDate="dataFimSelected"
                                    @input="changeStartDate"
                                    title=""
                                />
                            </div>
                            <div class="column">
                                <label for="periodo">
                                    {{ $t("periodo-final") }}
                                    <b-icon 
                                        icon="information" 
                                        size="is-small" 
                                        v-tippy 
                                        :title="$t('msg-campo-final-ultimo-acesso-aparelho')"
                                    />
                                </label>
                                <verified-date-picker
                                    dateType="endDate"
                                    :value="dataFimSelected"
                                    :startDate="dataInicioSelected"
                                    @input="changeEndDate"
                                    title=""
                                />
                            </div>
                        </div>
                    </div>
                </b-collapse>
                <!-- Botões -->
                <div class="columns mt-2 mb-1">
                    <div class="column is-6 has-text-centered">
                        <button class="delete-btn pl-4 pr-4" @click="limparFiltros()">
                            {{ $t('limpar-filtros') }}
                        </button>
                    </div>
                    <div class="column is-6 has-text-centered">
                        <button class="save-btn pl-4 pr-4" @click="pesquisar()">
                            {{ $t('pesquisar') }}
                        </button>
                    </div>
                </div>
                <!-- LISTAGEM -->
                <div class="aparelhos-table registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="aparelhos && !aparelhos.length" />
                    <b-table
                        v-else
                        class="data-table data-table-aparelhos"
                        :data="aparelhos ? aparelhos : []"
                        backend-sorting
                        backend-pagination
                        @sort="updateSort"
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.label != '' ? $t(f.label) : ''"
                            :sortable="f.sortable"
                            :width="f.width"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <!-- BOTÕES DE ACÃO ATIVAR/INATIVAR -->
                            <div v-if="f.key == 'acao'" style="text-align: center">
                                <div v-if="props.row.situacao == 'I'">
                                    <b-button
                                        v-if="permissao.update && !limiteQdaAtivos"
                                        type="is-success"
                                        @click="() => openModalAparelhos(props.row, 'A')"
                                        icon-right="check"
                                        position="is-left"
                                        v-tippy 
                                        :title="$t('ativar')"
                                    />
                                    <span v-else>---</span>
                                </div>
                                <div v-else>
                                    <b-button
                                        v-if="permissao.delete"
                                        type="is-danger"
                                        @click="() => openModalAparelhos(props.row, 'I')"
                                        icon-right="delete"
                                        position="is-left"
                                        v-tippy 
                                        :title="$t('inativar')"
                                    />
                                    <span v-else>---</span>
                                </div>
                            </div>

                            <div v-else-if="f.key == 'build_number'">
                                {{
                                    props.row.build_number
                                        ? props.row.build_number
                                        : '——'
                                }}
                            </div>

                            <div v-else-if="f.key == 'diasSemAcesso'">
                                {{
                                    props.row.diasSemAcesso
                                        ? props.row.diasSemAcesso
                                        : '——'
                                }}
                            </div>

                            <!-- COLUNA DATA DE ACESSO -->
                            <div v-else-if="f.key == 'dataacesso'">
                                {{
                                    props.row.dataacesso
                                        ? $moment(props.row.dataacesso).format('DD/MM/YYYY HH:mm:ss')
                                        : '——'
                                }}
                            </div>
                            <!-- COLUNA DATA DE INCLUSÃO -->
                            <div v-else-if="f.key == 'datainclusao'">
                                {{
                                    props.row.datainclusao
                                        ? $moment(props.row.datainclusao).format('L')
                                        : '—'
                                }}
                            </div>
                            <!-- COLUNA IMEI -->
                            <div v-else-if="f.key == 'imei'">
                                <span style="font-weight: bold">{{ props.row.imei }}</span>
                            </div>
                            <!-- TAG SE O APARELHO É DE TESTES -->
                            <div v-else-if="f.key == 'teste'">
                                <b-tag
                                    v-if="props.row.teste == 'S'"
                                    class="ml-3 is-warning is-small"
                                >
                                    {{ $t('teste') }}</b-tag
                                >
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <b-modal :active.sync="isAparelhosSelectOpen">
                        <AparelhosModal
                            @ativacaoInativacao="ativacaoInativacao"
                            @fecharModal="closeModal"
                            :aparelho="aparelho"
                            :tipo="tipo"
                        />
                    </b-modal>
                    <b-modal
                        class="export-opcoes"
                        :active.sync="isShowingTitle"
                        style="z-index: 1000"
                        @close="isShowingTitle = false"
                    >
                        <div
                            class="modal-card modal-default center"
                            style="max-width: 580px"
                        >
                            <section class="modal-card-body">
                                <div class="listing-header">
                                    <div class="title-breadcrumb center">
                                        <h1 class="title">
                                            {{ $t("exportacao-dados") }}
                                        </h1>
                                    </div>
                                </div>
                                <div class="columns p-4">
                                    {{ $t("title-exp") }}
                                </div>
                                <div class="columns is-full mx-1">
                                    <div class="titulo-input">
                                        <v-input
                                            v-model="tituloExportacao"
                                            :maxlength="100"
                                            :title="'titulo-exp'"
                                            :msg="'msg-campo-obrigatorio'"
                                        />
                                    </div>
                                </div>
                                <div class="columns ok">
                                    <div class="form-buttons2">
                                        <button
                                            class="delete-btn"
                                            type="button"
                                            @click="isShowingTitle = false"
                                        >
                                            {{ $t("cancelar") }}
                                        </button>
                                        <button
                                            class="save-btn"
                                            type="button"
                                            @click="saveExportacao()"
                                        >
                                            {{ $t("exportar-rel") }}
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </b-modal>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    /> 
                </div> 
            </div>
        </div>
    </div>
</template>

<script>
import ColaboradorService from "@/services/ColaboradorService";
import AparelhoService from '@/services/AparelhoService.js';
import MMChaveLiberacaoService from '@/services/MMChaveLiberacaoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import AparelhosModal from '@/components/colaborador/AparelhosModal';
import ExportacaoTipoService from "@/services/ExportacaoTipoService";
import ExportacaoService from "@/services/ExportacaoService";
import ExportacaoLogService from "@/services/ExportacaoLogService";
import ExportacaoDadosService from "@/services/ExportacaoDadosService";

export default {
    components: {
        ContainerLoader,
        AparelhosModal,
    },
    data() {
        return {
            ipaddress: '',
            updateThis: {},
            aparelhos: [],
            service_mm: new MMChaveLiberacaoService(this.$http, this.$router),
            service: new AparelhoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            exportacaoTipoService: new ExportacaoTipoService(this.$http,this.$router),
            exportacaoService: new ExportacaoService(this.$http, this.$router),
            exportacaoLogService: new ExportacaoLogService(this.$http,this.$router),
            exportacaoDadosService: new ExportacaoDadosService(this.$http, this.$router),
            fields: [
                {
                    key: 'nome',
                    label: 'nome',
                    sortable: true,
                    width: null,
                    sortFn: null,
                },
                {
                    key: 'login',
                    label: 'usuario',
                    sortable: true,
                    width: null,
                    sortFn: null,
                },
                { key: 'imei', label: 'imei', sortable: true, width: 450 },
                {
                    key: 'build_number',
                    label: 'build-aparelho',
                    sortable: true,
                    width: null,
                    sortFn: null,
                },
                {
                    key: 'teste',
                    label: 'em-teste',
                    sortable: false,
                    width: null,
                },
                {
                    key: 'diasSemAcesso',
                    label: 'dias-sem-acesso',
                    sortable: true,
                    width: null,
                    sortFn: null,
                },
                {
                    key: 'dataacesso',
                    label: 'data-acesso',
                    sortable: true,
                    width: 200,
                    sortFn: null,
                },
                {
                    key: 'datainclusao',
                    label: 'data-inclusao',
                    sortable: true,
                    width: 150,
                    sortFn: null,
                },
                {
                    key: 'acao',
                    label: 'acao',
                    sortable: false,
                    width: 50,
                    sortFn: null,
                },
            ],
            idclientesovis: 0,
            situacoes: [
                { label: 'Todos', id: 2 },
                { label: 'Ativo', id: 1 },
                { label: 'Inativo', id: 3 },
            ],
            situacoesEmTeste: [
                { label: 'Sim', id: 1, emteste: 'S' },
                { label: 'Não', id: 2, emteste: 'N' },
                { label: 'Todos', id: 3, emteste: '' },
            ],
            order: 'desc',
            column: 'datahorainc',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isAparelhosSelectOpen: false,
            message: '',
            aparelho: {},
            tipo: null,
            vendedorSelect: [],
            vendedorLoading: false,
            filtros: {
                dataInicio: null,
                dataFim: null,
                vendedor: [],
                emTeste: { label: 'Não', id: 2, emteste: 'N' },
                situacao: { label: 'Todos', id: 2 },
            },
            dataInicioSelected: null,
            dataFimSelected: null,
            vendedorSelected: null,
            exportacaoTipo: {},
            permissao: {},
            isShowingTitle: false,
            tituloExportacao: null,
            tipoExportacao: null,
            isSaving: false,
            tableExportacao: [],
            qtdAparelhosAtivos: 0,
            limiteQdaAtivos: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.hasPermissionAccess(
            'admin',
            'colaborador',
            'usuario-controle-aparelhos'
        );
        this.carregaExportacaoTipo();
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'controle-aparelhos' },
            });
        } else {
            this.ocultaAcaoAgrotis();
            this.carregarVendedores('');
            this.carregarDados();
            this.getIpAdress();
            this.qtdMaxAparelhoVsQtdAtivos();
        }
    },
    methods: {
        ocultaAcaoAgrotis() {
            // Oculta a ação de ativar/inativar aparelhos para clientes do parceiro Agrotis
            if (this.$store.state.user.clienteSovis.partner_id == 26) {
                this.permissao.update = false;
                this.permissao.delete = false;
            }
        },
        carregaExportacaoTipo() {
            // Indica qual a tela que será passada (ENUM ExportacaoTelas) para realizar a busca
            this.exportacaoTipoService.findByTela("CONTROLEAPARELHOS").then((body) => {
                if (body.content) {
                    this.exportacaoTipo = body.content;
                }
            });
        },
        onFilterChange(){
            setTimeout(() => {
                this.resize();
            }, 1000);
        },
        resize () {
            let neededHeight = (window.innerHeight - document.querySelector('.page').offsetHeight);
            let needHeightFinal = neededHeight - 163;
            if (this.aparelhos.length > 0) {

                setTimeout(() => {

                    this.isFixedHeader = needHeightFinal < document.querySelector('table.table').offsetHeight;
                    this.isFixedColumn = document.documentElement.clientWidth >= 768;

                    if(this.isFixedHeader){
                        this.tableHeight = `${needHeightFinal}px`;
                    }else{
                        this.tableHeight = 'auto';
                    }
                }, 16);
            }
        },
        changeStartDate(date) {
            this.dataInicioSelected = date;
        },
        changeEndDate(date) {
            this.dataFimSelected = date;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            this.isLoading = true;

            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            let filtros = this.geraFiltros();
            this.service
                .findAll(
                    this.$store.state.user.idClienteSovis,
                    currentPage - 1,
                    this.order,
                    this.column,
                    this.pagination.perPage,
                    filtros,
                    this.query
                )
                .then((r) => {
                    this.pagination.totalRows = r.totalElements;
                    this.aparelhos = r.content;
                    this.isLoading = false;
                })
                .catch((e) => {
                    console.error('Erro ao carregar aparelhos.');
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        getIpAdress() {
            this.isLoading = true;
            // GET request using fetch with error handling
            fetch("https://api.ipify.org?format=json")
                .then(async response => {
                    if (!response.ok) {
                        const error = data.message || response.statusText;
                        return Promise.reject(error);
                    }else {
                        return response.json();
                    }

                })
                .then(({ ip }) => {
                    this.ipaddress = ip;
                })
                .catch(error => {
                    console.error("Ocorreu um erro ao buscar o endereço IP do aparelho!", error);
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        updateSort(sort, order) {
            this.column = sort;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.query = this.removeAcentos(value);
            this.carregarDados();
        },
        //Solicitação da confirmação para realizar a ação
        confirmUpdate(item, situacao) {
            this.updateThis = { ...item };
            if (situacao === 1) {
                this.updateThis.situacao = 'A';
                this.updateAparelho(1);
            } else if (situacao === 2) {
                this.updateThis.situacao = 'A';
                this.updateAparelho(2);
            } else if (situacao === 0) {
                this.updateThis.situacao = 'I';
                this.updateAparelho(0);
            }
        },
        // Atualização
        updateAparelho(operacao) {
            // Cria o objeto que sera inserido na tabela mm_chave_liberacao
            let MMChaveLiberacao = {
                cliente_sovis_id: this.$store.state.user.idClienteSovis,
                vendedor_id: this.updateThis.vendedor_id,
                aparelho_id: this.updateThis.id,
                imei: this.updateThis.imei,
                operacao: '',
                mm_user_id: 1,
                mm_user_name: this.$store.state.user.nome,
                codigo_chamado: null,
                observacao: null,
                faturar: '',
                faturado: 'N',
                datafaturado: null,
                ip: this.ipaddress,
                macaddress: 'AAAA:BBBB:CCCC:DDDD',
                license_key: this.updateThis.license_key,
                aparelho_inativado_id: '0',
                id_fvw_usuarios: this.$store.state.user.id,
            };

            let aparelho = {
                idaparelho: this.updateThis.id,
                situacao: this.updateThis.situacao,
            };

            this.service
                .updateSituacao(aparelho)
                .then((r) => {
                    // @71530 - TROCA DE IMEI
                    if (operacao === 2) {
                        MMChaveLiberacao.operacao = 'T';
                        // Consulta se o IMEI já existe, caso exista não precisa faturar.
                        this.service_mm
                            .find(MMChaveLiberacao.imei, this.$store.state.user.idClienteSovis)
                            .then((imei) => {
                                if (imei.content == true) {
                                    MMChaveLiberacao.faturar = 'N';
                                } else {
                                    MMChaveLiberacao.faturar = 'S';
                                }
                                // Se o aparelho for de teste sempre irá colocar para NÃO faturar
                                if (this.updateThis.teste == 'S') {
                                    MMChaveLiberacao.faturar = 'N';
                                }
                                //Realiza a alteração do status do aparelho
                                this.service_mm.save(MMChaveLiberacao).then((t) => {
                                    this.$root.showMessage('success', 'msg-reativou-aparelho');
                                });
                            });
                    } else if (operacao === 1) {
                        MMChaveLiberacao.operacao = 'A';
                        // Consulta se o IMEI já existe, caso exista não precisa faturar.
                        this.service_mm
                            .find(MMChaveLiberacao.imei, this.$store.state.user.idClienteSovis)
                            .then((imei) => {
                                if (imei.content == true) {
                                    MMChaveLiberacao.faturar = 'N';
                                } else {
                                    MMChaveLiberacao.faturar = 'S';
                                }
                                // Se o aparelho for de teste sempre irá colocar para NÃO faturar
                                if (this.updateThis.teste == 'S') {
                                    MMChaveLiberacao.faturar = 'N';
                                }
                                //Realiza a alteração do status do aparelho
                                this.service_mm.save(MMChaveLiberacao).then((t) => {
                                    this.$root.showMessage('success', 'msg-reativou-aparelho');
                                });
                            });
                        //INATIVACAO
                    } else if (operacao === 0) {
                        MMChaveLiberacao.operacao = 'I';
                        MMChaveLiberacao.faturar = 'N';
                        //Realiza a alteração do status do aparelho
                        this.service_mm.save(MMChaveLiberacao).then((t) => {
                            this.$root.showMessage('success', 'msg-inativou-aparelho');
                        });
                    }
                })
                .then(() => {
                    this.carregarDados();
                })
                .catch((e) => {
                    if (this.$te(e.body.message)) {

                        this.$root.showMessage("alert", this.$t(e.body.message), true);

                        setTimeout(() => {
                            location.reload();
                        }, 1000);
            
                    } else if (e.body.message) {
                        this.$root.showMessage("alert", e.body.message, true);
                    } else {
                        console.error('Erro ao alterar a situação.', e);
                        this.$root.showMessage('error', 'msg-problema-realizar-acao');
                    }
                })
                .finally((_) => {
                    this.closeModal();
                });
        },
        removePrompt() {
            this.updateThis = null;
        },
        // @71530 - ADICIONADO MODAL PARA OPERAÇÕES DE ATIVAÇÃO/INATIVAÇÃO
        openModalAparelhos(props, tipo) {
            this.isAparelhosSelectOpen = true;
            if (tipo === 'A') {
                this.tipo = 1;
            } else {
                this.tipo = 0;
            }
            this.aparelho = props;
        },
        closeModal() {
            this.isAparelhosSelectOpen = !this.isAparelhosSelectOpen;
        },
        ativacaoInativacao(imeiObj) {
            // @71530 - OPERAÇÃO 2: TROCA // OPERAÇÃO 1: ADIÇÃO // OPERAÇÃO 0: DESATIVAÇÃO
            if (imeiObj.imeiDesativacao) {
                this.confirmUpdate(imeiObj.imeiOperacao, 2);
                this.confirmUpdate(imeiObj.imeiDesativacao, 0);
            } else {
                if (imeiObj.operacao == 'A') {
                    this.confirmUpdate(imeiObj.imeiOperacao, 1);
                } else {
                    this.confirmUpdate(imeiObj.imeiOperacao, 0);
                }
            }
        },
        carregarVendedores(searchQuery) {
            this.vendedorLoading = true;
            this.colaboradorService
                .findListAssociated(searchQuery)
                .then((value) => {
                    this.vendedorSelect = value.content;
                })
                .catch(e => {
                    console.error( `Erro ao realizar pesquisa de vendedores. Termo: [${searchQuery}]`, e );
                })
                .finally(f => {
                    this.vendedorLoading = false;
                });
        },
        geraFiltros(){
            return {
                vendedores: this.filtros.vendedor
                    ? this.filtros.vendedor.map((vendedor) => vendedor.idvendedor) : [],
                situacao: this.filtros.situacao.id,
                emTeste: this.filtros.emTeste.emteste,
                inicio: this.filtros.dataInicio
                    ? this.$moment(this.filtros.dataInicio).format("YYYY-MM-DD")
                    : null,
                fim: this.filtros.dataFim
                    ? this.$moment(this.filtros.dataFim).format("YYYY-MM-DD")
                    : null,
            };
        },
        checkExport(tipo) {
            if (this.aparelhos.length > 0){
                this.tipoExportacao = tipo;
                this.isShowingTitle = true;
            }else {
                this.$root.showMessage("alert", "msg-valida-tabela");
            }
        },
        saveExportacao() {
            if (this.isNull(this.tituloExportacao)) {
                this.$root.showMessage("alert", "msg-valida-titulo");
            } else {
                this.isSaving = true;
                this.isShowingTitle = false;
                let exportacao = {
                    idexportacao: null,
                    titulo: this.tituloExportacao,
                    processoexportado: this.tipoExportacao,
                    situacao: "EXPORTANDO",
                    usuario: {
                        idusuarioerp: this.$store.state.user.idusuarioerp,
                    },
                    exportacaotipo: {
                        idexportacaotipo: this.exportacaoTipo.idexportacaotipo, 
                        //IDEXPORTACAOTIPO (REFERE-SE A QUAL TELA ESTA CHAMANDO A EXPORTACAO)
                    },
                };
                // salva o inicio da gravação em fvw_exportacao
                let is_success_content = null;
                this.exportacaoService
                    .save(exportacao)
                    .then(response => {
                        if (!this.isNull(response.content)) {
                            is_success_content = response.content;
                            this.$root.showMessage("success", "msg-exp-solicitada");
                        } else {
                            this.$root.showMessage("error", "msg-erro-exp-gerar");
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage("error", "msg-erro-exp-gerar");
                    })
                    .finally((_) => {
                        if (is_success_content != null) {
                            this.saveLog(is_success_content, 'controle-aparelhos'); 
                            this.gerarArquivoExportacao(is_success_content);
                        }
                        is_success_content = null;
                        this.isSaving = false;
                    });
                }
        },
        // Salva os dados na tabela fvw_exportacaolog
        saveLog(exportacao, tipo) {
            let exportacaoLog = {
                // Objeto criado que será enviado ao banco
                destino: null,
                acao: "Solicitação da exportação listagem " + tipo,
                exportacao: exportacao,
                usuario: {
                    idusuarioerp: exportacao.usuario.idusuarioerp,
                },
            };
            this.exportacaoLogService
                .save(exportacaoLog)
                .then((r) => {})
                .catch((e) => {
                    console.error("Erro ao salvar log exportação.", e);
                    this.$root.showMessage("error", "msg-erro-exp-gerar");
                });
        },
        gerarArquivoExportacao(exportacao){
            let filtros = this.geraFiltros();
            this.service
                .findAll(
                    this.$store.state.user.idClienteSovis,
                    0,
                    this.order,
                    this.column,
                    20000,
                    filtros,
                    this.query
                )
            .then( value => {
                if(value.content){
                    this.exportacao(exportacao, value.content);
                }
            })
            .catch(error => {
                console.error('Erro ao trazer dados de itens.', error);
                this.$root.showMessage('error', 'msg-erro-exp-gerar');
            })
        },
        exportacao(exportacao, content){
            this.tableExportacao = content;

            this.tableExportacao.forEach((table) => {
                table.dataacessoExporta = this.$moment(table.dataacesso).format('DD/MM/YYYY HH:mm:ss');
                table.datainclusaoExporta = this.$moment(table.datainclusao).format('L');
            });
                 
            let exportacaoControleAparelhos = {
                exportacao: exportacao,
                usuario: this.$store.state.user,
                aparelhos: this.tableExportacao,
            };

            this.exportacaoDadosService
                .saveControleAparelhos(
                    exportacaoControleAparelhos,
                    this.tipoExportacao,
                )
                .then((this.tituloExportacao = ""))
                .catch((e) => {
                    console.error(
                        "Erro ao salvar exportação",
                        this.tipoExportacao,
                        e
                    );
                    this.$root.showMessage("error", "msg-erro-exp-gerar");
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },
        limparFiltros () {
            this.vendedorSelected = [];
            this.dataInicioSelected = null;
            this.dataFimSelected = null;
        },
        pesquisar () {
            this.filtros.vendedor = this.vendedorSelected;
            this.filtros.dataInicio = this.dataInicioSelected;
            this.filtros.dataFim = this.dataFimSelected;
            this.carregarDados();
        },
        qtdMaxAparelhoVsQtdAtivos() {
            this.service.qtdAparelhosAtivos(this.$store.state.user.clienteSovis.id)
                .then(body => {
                    this.qtdAparelhosAtivos = body.content;
                })
                .finally(_ => {
                    this.limiteQdaAtivos = 
                        this.$store.state.user.clienteSovis.qtde_max_usuario_aparelho > 0 &&
                        this.qtdAparelhosAtivos >= this.$store.state.user.clienteSovis.qtde_max_usuario_aparelho;

                    this.$forceUpdate();
                });
        }
    },
};
</script>

<style lang="scss" scoped>
@import "../../../mixins.scss";
#main {
    padding: 0 20px;
    height: 100%;

    h1.title {
        padding-top: 0px;
        margin-bottom: 0 !important;
    }
    .tag {
        height: 35px;
        width: 120px;
    }

    .page {
        position: relative;
        padding-left: 0;

        .control-bar {
            margin-bottom: 0;

            .column:first-child {
                padding-bottom: 0.25rem;
            }

            .column:last-child {
                padding-top: 0.25rem;
            }

            .date-opts {
                margin-bottom: 0.5rem !important;
            }

            .date-group {
                justify-content: center;
                flex-wrap: wrap;
            }

            .periodo-custom {
                width: 100%;
                justify-content: center;
                align-items: center;

                .periodo-input {
                    margin: 0 1rem;
                    padding: 0.2rem;
                    height: 27px;
                    width: 100px;
                    font-size: 0.75rem;
                }
            }

            button.btn-search {
                height: 27px;
                font-size: 12px;
                color: $sovis-white;
                @include gradient-button();
            }
        }

        td.strike > div:not(.no-strike) {
            text-decoration: line-through;
        }
    }
}

.column {
    @include default-size-column;
    padding-top: 20px !important;
    padding-bottom: 20px !important;
}
.filter-page {
    position: relative;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    padding: 0.6rem 1rem 1rem 1rem;
    .v-select {
        height: 27px;
    }
}

.card {
    margin-top: 10px;
    overflow: initial;
    color: $darker-gray-color;
    display: inline;
    .card-header-title {
        color: $darker-gray-color;
        justify-content: space-between;
        padding: 0.3rem;
    }

    .card-content {
        padding: 0.9rem;

        .card-content-top {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
        }
    }
}
.data-exporta {
    display: inline-block;
    padding: 0 4px 0 0;
}
.mt-2-custom {
    display: inline-block;
    padding: 23px 0 0 0;
}
.filtro-header {
    display: flex;
    align-items: center;
}
.export-opcoes {
    .modal {
        display: flex;
        justify-content: center;
    }
    .modal-content {
        width: 40% !important;
    }
    .modal-card {
        width: auto !important;
    }
    .titulo-input {
        width: 100%;
    }
    .form-buttons2 {
        top: 20px;
        display: flex;
        margin: 0 auto;

        .save-btn,
        .delete-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            color: $sovis-white;
            font-size: 12px;
            height: 47px;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px !important;
            @include gradient-button();
        }

        .delete-btn {
            right: 225px;
            color: $darker-gray-color;
            @include exclude-button();
        }
    }
    .ok {
        margin: 0;
    }
}
@media screen and (max-width: 1024px) {
    .header-search {
        width: 100%;
    }
    .column {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
        width: 100%;
    }
    .mt-2-custom {
        margin-top: 0;
        padding: 0;
    }
}

</style>
<style lang="scss">
    .data-table-aparelhos {
        overflow-y: auto;
        .table-wrapper{
            min-width: 1600px;
        }
    }
</style>